import AmioHttpService from './amio-http.service'

class BotTemplatesService extends AmioHttpService {

  list() {
    return this.requestGet('/bot-templates')
      .then(response => response.data)
      .then(botTemplates => {
        return botTemplates.map(adapt)
      })
      .catch(err => {
        throw this.handleError(err)
      })
  }

}

function adapt(botTemplate) {
  return {
    id: botTemplate.id,
    botLanguage: botTemplate.bot_language,
    botTimezone: botTemplate.bot_timezone,
    botType: botTemplate.bot_type,
    name: botTemplate.name,
    variablesPrefix: botTemplate.variables_prefix
  }
}

export default new BotTemplatesService()
